//import packages from node modules
import React from "react"
import PropTypes from 'prop-types'
import {change, Field, formValueSelector} from "redux-form"
import renderHTML from "react-render-html"

//import utilities functions
import {requiredFieldValidation} from "../../form/validation"
import {isPremiumDomain} from "../../../../utilities/function/configuration"
import PRODUCT_API from '../../../../utilities/api/product'

//import shared component
import SimpleCheckbox from "../../form/checkbox/simple"
import Dropdown from "../../form/dropdown"
import TextField from "../../form/textfield"
import Toggle from "../../form/toggle"

//import internals
import {SELECT_DOMAIN_CONFIG_FORM} from "./SelectDomainConfigForm"
import {AUTO_RENEW, ELIGIBILITY_NUMBER, ELIGIBILITY_TYPE, EPP_CODE, ID_PROTECTION} from "./index"
import AsyncValidationField from "./AsyncValidationField";
import {useSelector} from "react-redux";

//main component
const DomainConfigFields = ({selectedProduct,order_type,form,getInputName,item,dispatch}) => {

    const formSelector = formValueSelector(SELECT_DOMAIN_CONFIG_FORM)
    const FIELD_ELIGIBILITY_TYPE = getInputName(ELIGIBILITY_TYPE)
    const {eligibilityType} = useSelector(state=>({
        eligibilityType: formSelector(state, FIELD_ELIGIBILITY_TYPE)
    }))
    const {attributes} = selectedProduct
    const {custom_fields} = attributes
    const renderFields = () => {
        if (custom_fields && custom_fields.length && order_type === 'register') {
            return custom_fields.map((field, index) => {
                const {options, type, name,description} = field
                const getList = () => {
                    if (type === 'dropdown') {
                        if (options && options.length > 1) {
                            return options.map((item) => {
                                return ({
                                    label: item,
                                    value: item
                                })
                            })
                        }
                    }
                    return []
                }
                const getFirstItemList = () => {
                    if (type === 'dropdown') {
                        if (options && options.length > 1) {
                            return options[0]
                        }
                    }
                    return null
                }
                const renderCheckbox = () => {
                    const checkboxcallback = () => {
                        const formvalues = form[SELECT_DOMAIN_CONFIG_FORM].values
                        if (item && formvalues['domain_config'] && formvalues['domain_config'].length > 0) {
                            if (item.uuid) {
                                const config = formvalues['domain_config'].find(i => i.domain + i.tld === item.name)
                                if(config){
                                    dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName(name), !config['whois_opt-out']))
                                }
                            }
                            if (item.domainSearchResult) {
                                const config = formvalues['domain_config'].find(i => i.domain + i.tld === item.domainSearchResult.domain + item.domainSearchResult.tld)
                                if(config){
                                    dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName(name), !config['whois_opt-out']))
                                }
                            }
                        }
                    }
                    return (
                        <div className={'of-domain-config__field-wrapper'} key={index}>
                            <Field label={description?renderHTML(description):name} name={getInputName(name)} component={SimpleCheckbox} callback={checkboxcallback}/>
                        </div>
                    )
                }

                const renderTextField = () => {
                    const renderDefaultTextfield = () => {
                        return (
                            <div className={'of-domain-config__field-wrapper'} key={index}>
                                <Field
                                    label={name}
                                    component={TextField}
                                    name={getInputName(name)}
                                    validate={[requiredFieldValidation]}
                                    placeholder={name}
                                    description={description}
                                />
                            </div>
                        )
                    }
                    const renderEligibilityNumberField = () =>{
                        const errorMessages = {
                           validation: `Invalid ${eligibilityType} number`,
                           heading: `We don't recognise that ${eligibilityType} number`,
                           description: `Please ensure the ${eligibilityType} number you are entering is correct and active. Otherwise, you can proceed with the transfer by clicking the button below and correcting the eligibility information later.`,
                           forceButton: true
                        }
                        const field = {
                            name: getInputName(ELIGIBILITY_NUMBER),
                            label: ELIGIBILITY_NUMBER,
                            placeholder: ELIGIBILITY_NUMBER
                        }
                        return (
                            <AsyncValidationField
                                key={index}
                                requireButton={false}
                                errorMessages={errorMessages}
                                field={field}
                                getInputName={getInputName}
                                asyncValidation={PRODUCT_API.submitAUSCheck}
                                item={item}
                            />

                        )
                    }

                    switch (name){
                        case ELIGIBILITY_NUMBER:
                            return (renderEligibilityNumberField())
                        default:
                            return (renderDefaultTextfield())
                    }
                }

                const renderDropdown = () => {
                    return (
                        <div className={'of-domain-config__field-wrapper'} key={index}>
                            <Field label={name} initialValue={getFirstItemList()} validate={[requiredFieldValidation]}
                                   component={Dropdown} name={getInputName(name)} list={getList()} description={description}/>
                        </div>
                    )
                }

                switch (type) {
                    case 'dropdown':
                        return renderDropdown()
                    case 'checkbox':
                        return renderCheckbox()
                    default:
                        return renderTextField()
                }
            })
        }
        return (<></>)
    }
    const renderMetaFields = () => {
        const {meta} = attributes
        const renderIDProtection = () => {
            if (meta && meta.length) {
                const isAllowIDProtection = meta.find(item => item.identifier === 'allow_id_protection')
                if (isAllowIDProtection) {
                    return (
                        <Field className={'of-domain-config__toggle'} name={getInputName(ID_PROTECTION)} label={ID_PROTECTION}
                               component={Toggle} initialValue={true} tooltip={{
                            description: "Protect your personal information and reduce the amount of spam to your inbox by enabling ID Protection. We recommend you keep this enabled."
                        }}/>
                    )
                }
            }
            return (<></>)
        }
        const renderEPPCode = () => {
            if (meta && meta.length) {
                const isRequireEPPCode = meta.find(item => item.identifier === 'require_epp_code')
                if (isRequireEPPCode && order_type === 'transfer') {
                    const getEPPCodeDescription = () => {
                        let desc = 'Every domain name has a unique EPP key or domain password that you will need to enter during the ordering process.'
                        if(window.app_config && window.app_config.epp_code_link){
                            desc = `${desc} <a href="${window.app_config.epp_code_link}" target="_blank">Where do I find this code?</a>`
                        }
                        return desc
                    }
                    const field = {
                        name: getInputName(EPP_CODE),
                        label: "EPP Code",
                        placeholder: "EPP Code",
                        description: getEPPCodeDescription()
                    }
                    return (
                        <AsyncValidationField
                            requireButton={true}
                            field={field}
                            getInputName={getInputName}
                            asyncValidation={PRODUCT_API.submitEPPCheck}
                            item={item}
                        />
                    )
                }
            }
            return (<></>)
        }
        const renderAutoRenew = () => {
            if(!isPremiumDomain(item)){
                return (
                    <Field className={'of-domain-config__toggle'} name={getInputName(AUTO_RENEW)} label={AUTO_RENEW}
                           component={Toggle} initialValue={true} tooltip={{
                        description: 'We\'ll automatically invoice you 14 days before your domain is due to expire and attempt to charge any stored credit card.'
                    }}/>
                )
            }
            return (<></>)
        }
        return (
            <div className={'of-domain-config__meta-fields'}>
                {renderEPPCode()}
                <div className={'of-domain-config__field-wrapper'}>
                    {renderAutoRenew()}
                    {renderIDProtection()}
                </div>
            </div>
        )
    }
    return (<div className={'of-domain-config__bottom'}>
        <div className={'of-domain-config__wrapper of-domain-config__wrapper--bottom'}>
            {renderFields()}
            {renderMetaFields()}
        </div>
    </div>)
}

DomainConfigFields.propTypes = {
    selectedProduct: PropTypes.object,
    order_type: PropTypes.string,
    form: PropTypes.object,
    getInputName: PropTypes.func,
    item: PropTypes.object,
    dispatch: PropTypes.func
}

export default DomainConfigFields